




















import { defineComponent } from "@vue/composition-api"

export default defineComponent({
  name: "PopupBox",
  props: {
    title: {
      type: String,
      required: true
    },
    msg: {
      type: String,
      required: true
    },
    isShown: {
      required: true
    },
    hideClose: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("update:isShown", false)
    }
  }
})
